import { useState, useCallback, useRef } from 'react';

const useAsyncPaginatedOptions = (loadOptions, watch, searchValueRef, isDisablePagination = false) => {
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(false);
    const pageRef = useRef(1);
    const initialFetchRef = useRef(false);

    const fetchOptions = useCallback(async (searchValue, isSearch) => {
        try {
            setLoading(true);
            if(isSearch) {
                pageRef.current = 1;
            }
            const response = await loadOptions(searchValue, watch?.(), pageRef.current);
            const newOptions = response.rows || [];
            const { isLoadMore } = response;

            if (isSearch) {
                setOptions([...newOptions]);
                pageRef.current = 1;
            } else {
                setOptions(prev => [...prev, ...newOptions]);
            }

            if (isLoadMore) {
                pageRef.current += 1;
                if(isDisablePagination && searchValue?.length) {
                    setHasMore(false);
                }else {
                    setHasMore(true);
                }
            } else {
                setHasMore(false);
            }
        } catch (error) {
            console.error("Error fetching options:", error);
            setOptions([]);
            setHasMore(false);
        } finally {
            setLoading(false);
        }
    }, [loadOptions, watch]);


    const initialFetch = useCallback(async () => {
        if (initialFetchRef.current) return;
        initialFetchRef.current = true;
        await fetchOptions("");
    }, [fetchOptions]);

    const loadMore = useCallback(() => {
        if (!loading && hasMore) {
            fetchOptions(searchValueRef?.current);
        }
    }, [hasMore]);

    return {
        options,
        loading,
        hasMore,
        fetchOptions,
        loadMore,
        initialFetch
    };
};

export default useAsyncPaginatedOptions;